import * as XLSX from 'xlsx';
import { excludeDownload } from './constVariables';
import { postUsageAnalytics } from '../utils/apiServices';
import { downloadExcelHeaderName, Regex } from '../constants/contants'
export function downloadBulk(data, name) {
    // console.log("down = ", data)
    // let ws = XLSX.utils.json_to_sheet(data);
    // let wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, "sheet");

    const excludeDownloadHeading = [
        { name: 'first_name', value: 'FIRST NAME' },
        { name: 'plant_fk__plant_name', value: 'PLANT NAME' },
        { name: 'vin_number', value: 'VEHICLE' },
        { name: 'vin_status', value: 'VEHICLE STATUS' },
        { name: 'area_fk__area_name', value: 'AREA NAME' },
        { name: 'zone_fk__zone_name', value: 'ZONE NAME' },
        { name: 'data_source', value: 'FROM' },
        { name: 'last_sync_date', value: 'STATUS UPDATED AT' },
        { name: 'fuel_vin_fk__fuel_updated_at', value: 'FUEL UPDATED AT' },
        { name: 'dispatch_updated_at', value: 'LOCATION UPDATED AT' },
    ]

    var Heading = [[]]
    Object.keys(data[0]).map((header, index) => {
        // console.log("header = ", header);
        var a = excludeDownloadHeading.filter((o) => o.name === header);
        // console.log("a = ", a)
        if (a.length) {
            Heading[0].push(a[0].value)
        } else {
            Heading[0].push(header.replace(/_+/g, ' ').replace("fk", "").toUpperCase());
        }
    })
    var today = new Date();
    var date = String(today.getFullYear()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0') + '_' + String(today.getHours()).padStart(2, '0') + "-" + String(today.getMinutes()).padStart(2, '0') + "-" + String(today.getSeconds()).padStart(2, '0');
    // console.log("date = ", date);

    //Had to create a new workbook and then add the header
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([])
    // XLSX.WorkSheet = ws;
    XLSX.utils.sheet_add_aoa(ws, Heading);
    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${name}_${date}.xlsx`);
}

export function simpleAlert(value) {
    alert(value)
    return null;
}

export function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
    // console.log(array, comparator);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);

        if (order !== 0) return order;
        return a[1] - b[1];
    });
    // console.log(stabilizedThis);
    return stabilizedThis.map((el) => el[0]);
}
export function dateFormat(date, seconds) {
    if (date) {
        var options = { hour12: false, weekday: undefined, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: seconds ? 'numeric' : undefined };
        return new Date(date).toLocaleDateString("en-IN", options).replace(",", ' ');
    }
    else {
        return "-"
    }
}
const dataCleaning = (obj) => {
    // console.log("oob = ", obj)
    if (obj) {
        var new_Data = Object.keys(obj).reduce((acc, key) => {
            // console.log("obj", obj, acc[key]);
            try {
                acc[key.replace(/_+/g, ' ').replace("fk", "").toUpperCase()] = String(obj[key])[0] ? String(obj[key])[0].toUpperCase() + String(obj[key]).slice(1) : "-";
                // console.log("acc", acc)
                return acc;
            }
            catch {
                return obj
            }
        }, {});
        // console.log("obbbbbb = ",obj)
        return new_Data
    } else { return {} }
}

export const downloadData = (selectedRows, data, fileName) => {
    var downloadData = []
    if (data.length > 0) {
        data.filter(dataa => {
            excludeDownload.map(d => dataa.hasOwnProperty(d) ? delete (dataa[d]) : null);
        });
        // console.log("Data = ", data)
        selectedRows.map((item, index) => item ? downloadData.push(data[index]) : null)
        // console.log("downloadData = ", downloadData);

        downloadBulk(downloadData, fileName)
    }
}
export const getPlantValue = () => {
    if (JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))) {
        return JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))
    }
    else {
        window.location.href = "/"
    }
    // var a = JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))
    // return a
}


export const downloadBulkSearch = async function () {
    const csvdata = csvmaker(downloadExcelHeaderName);
    // setCsvRows([]);
    download(csvdata);
}

const csvmaker = function (data) {
    const csvRow = [];
    const headers = Object.keys(data);
    csvRow.push(headers.join(','));
    const values = Object.values(data).join(',');
    csvRow.push(values)
    return csvRow.join('\n')
}

export const download = function (data) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', 'Bulk_Search_Template.csv');
    a.click()
}

export const processData = dataString => {
    const dataStringLines = dataString.split(Regex.excelDataString);
    const headers = dataStringLines[0].split(Regex.excel);
    const list = [];
    for (let i = 1; i < dataStringLines.length; i++) {
        const row = dataStringLines[i].split(Regex.excel);
        if (headers && row.length == headers.length) {
            const obj = {};
            for (let j = 0; j < headers.length; j++) {
                let d = row[j];
                if (d.length > 0) {
                    if (d[0] == '"')
                        d = d.substring(1, d.length - 1);
                    if (d[d.length - 1] == '"')
                        d = d.substring(d.length - 2, 1);
                }
                if (headers[j]) {
                    obj[headers[j]] = d;
                }
            }
            // remove the blank rows
            if (Object.values(obj).filter(x => x).length > 0) {
                list.push(obj);
            }
        }
    }

    // prepare columns list from headers
    const columns = headers.map(c => ({
        name: c,
        selector: c,
    }));

    return [list, columns];
    // setData(list);
    // setColumns(columns);

}

export const postUsageAnalyticsCall = async (username, userId, pathname, login_time, operation, duration) => {
    const payload = {
        user_name: username,
        user_id: userId,
        login_page: pathname,
        login_time: login_time,
        operation: operation,
        duration: duration,
        plant_fk: (JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))).value != "cv_all" ||
            (JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))).value != "pv_all" ?
            (JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))).value : ""
    }
    // console.log("Payload = ", payload, (JSON.parse(window.localStorage.getItem('PLANT_FILTER_NAME'))).value)
    if (process.env.REACT_APP_DOMAIN_TYPE == 'dev' || process.env.REACT_APP_DOMAIN_TYPE == 'prod') {
        const response = await postUsageAnalytics(payload)
            .then((res) => {
                // console.log("success inside utils", res.data);
            }).catch((error) => {
                console.log("inside catch", error)
            });
    }
}

export const removeDuplicateBasedonKey = (arr, key) => {
    // const key = 'closure_uid';
    const arrayUniqueByKey = [...new Map(arr.map(item => [item[key], item])).values()];
    // console.log(arrayUniqueByKey);
    return arrayUniqueByKey;
}